import {
  RequestUserActivationRequest,
  User,
  UserPatchRequest,
} from '@interfaces/users.interface';

import api from './';

export const {
  usePatchCurrentUserMutation,
  useRequestActivationMutation,
  useVerifyActivationTokenQuery,
  useActivateMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    patchCurrentUser: build.mutation<User, UserPatchRequest>({
      query: (body) => ({
        url: 'users/me',
        method: 'PATCH',
        body,
      }),
    }),
    requestActivation: build.mutation<void, RequestUserActivationRequest>({
      query: (body) => ({
        url: `users/activate/request`,
        method: 'POST',
        body,
      }),
    }),
    verifyActivationToken: build.query<void, string>({
      query: (token) => ({
        url: `users/activate/${token}`,
        method: 'GET',
      }),
    }),
    activate: build.mutation<void, string>({
      query: (token) => ({
        url: `users/activate/${token}`,
        method: 'POST',
      }),
    }),
  }),
});
